import * as ambassadorWixFastgalleryItemV1Item from './fastgallery-item-v1-item-items.http.js';
import * as ambassadorWixFastgalleryItemV1ItemTypes from './fastgallery-item-v1-item-items.types.js';
import * as ambassadorWixFastgalleryItemV1ItemUniversalTypes from './fastgallery-item-v1-item-items.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createItem(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.CreateItemRequest,
  ambassadorWixFastgalleryItemV1ItemTypes.CreateItemRequest,
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.CreateItemResponse,
  ambassadorWixFastgalleryItemV1ItemTypes.CreateItemResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFastgalleryItemV1Item.createItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getItem(): __PublicMethodMetaInfo<
  'GET',
  { itemId: string },
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.GetItemRequest,
  ambassadorWixFastgalleryItemV1ItemTypes.GetItemRequest,
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.GetItemResponse,
  ambassadorWixFastgalleryItemV1ItemTypes.GetItemResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions = ambassadorWixFastgalleryItemV1Item.getItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/items/{itemId}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateItem(): __PublicMethodMetaInfo<
  'PATCH',
  { itemId: string },
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.UpdateItemRequest,
  ambassadorWixFastgalleryItemV1ItemTypes.UpdateItemRequest,
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.UpdateItemResponse,
  ambassadorWixFastgalleryItemV1ItemTypes.UpdateItemResponse
> {
  const payload = { item: { id: ':itemId' } } as any;

  const getRequestOptions =
    ambassadorWixFastgalleryItemV1Item.updateItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/items/{item.id}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteItem(): __PublicMethodMetaInfo<
  'DELETE',
  { itemId: string },
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.DeleteItemRequest,
  ambassadorWixFastgalleryItemV1ItemTypes.DeleteItemRequest,
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.DeleteItemResponse,
  ambassadorWixFastgalleryItemV1ItemTypes.DeleteItemResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixFastgalleryItemV1Item.deleteItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/items/{itemId}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryItems(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.QueryItemsRequest,
  ambassadorWixFastgalleryItemV1ItemTypes.QueryItemsRequest,
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.QueryItemsResponse,
  ambassadorWixFastgalleryItemV1ItemTypes.QueryItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFastgalleryItemV1Item.queryItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/items/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateExtendedFields(): __PublicMethodMetaInfo<
  'POST',
  { id: string },
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.UpdateExtendedFieldsRequest,
  ambassadorWixFastgalleryItemV1ItemTypes.UpdateExtendedFieldsRequest,
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.UpdateExtendedFieldsResponse,
  ambassadorWixFastgalleryItemV1ItemTypes.UpdateExtendedFieldsResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixFastgalleryItemV1Item.updateExtendedFields(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items/{id}/update-extended-fields',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkCreateItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.BulkCreateItemsRequest,
  ambassadorWixFastgalleryItemV1ItemTypes.BulkCreateItemsRequest,
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.BulkCreateItemsResponse,
  ambassadorWixFastgalleryItemV1ItemTypes.BulkCreateItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFastgalleryItemV1Item.bulkCreateItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/items/create',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpdateItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.BulkUpdateItemsRequest,
  ambassadorWixFastgalleryItemV1ItemTypes.BulkUpdateItemsRequest,
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.BulkUpdateItemsResponse,
  ambassadorWixFastgalleryItemV1ItemTypes.BulkUpdateItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFastgalleryItemV1Item.bulkUpdateItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/items/update',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkDeleteItems(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.BulkDeleteItemsRequest,
  ambassadorWixFastgalleryItemV1ItemTypes.BulkDeleteItemsRequest,
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.BulkDeleteItemsResponse,
  ambassadorWixFastgalleryItemV1ItemTypes.BulkDeleteItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFastgalleryItemV1Item.bulkDeleteItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/bulk/items/delete',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function removeItemFromTrashBin(): __PublicMethodMetaInfo<
  'DELETE',
  { itemId: string },
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.RemoveItemFromTrashBinRequest,
  ambassadorWixFastgalleryItemV1ItemTypes.RemoveItemFromTrashBinRequest,
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.RemoveItemFromTrashBinResponse,
  ambassadorWixFastgalleryItemV1ItemTypes.RemoveItemFromTrashBinResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixFastgalleryItemV1Item.removeItemFromTrashBin(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/items/trash-bin/{itemId}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function restoreItemFromTrashBin(): __PublicMethodMetaInfo<
  'POST',
  { itemId: string },
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.RestoreItemFromTrashBinRequest,
  ambassadorWixFastgalleryItemV1ItemTypes.RestoreItemFromTrashBinRequest,
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.RestoreItemFromTrashBinResponse,
  ambassadorWixFastgalleryItemV1ItemTypes.RestoreItemFromTrashBinResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixFastgalleryItemV1Item.restoreItemFromTrashBin(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/items/trash-bin/{itemId}/restore',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getDeletedItem(): __PublicMethodMetaInfo<
  'GET',
  { itemId: string },
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.GetDeletedItemRequest,
  ambassadorWixFastgalleryItemV1ItemTypes.GetDeletedItemRequest,
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.GetDeletedItemResponse,
  ambassadorWixFastgalleryItemV1ItemTypes.GetDeletedItemResponse
> {
  const payload = { itemId: ':itemId' } as any;

  const getRequestOptions =
    ambassadorWixFastgalleryItemV1Item.getDeletedItem(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/items/trash-bin/{itemId}',
    pathParams: { itemId: 'itemId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listDeletedItems(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.ListDeletedItemsRequest,
  ambassadorWixFastgalleryItemV1ItemTypes.ListDeletedItemsRequest,
  ambassadorWixFastgalleryItemV1ItemUniversalTypes.ListDeletedItemsResponse,
  ambassadorWixFastgalleryItemV1ItemTypes.ListDeletedItemsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixFastgalleryItemV1Item.listDeletedItems(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/items/trash-bin',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Item as ItemOriginal,
  Link as LinkOriginal,
  LinkType as LinkTypeOriginal,
  LinkTypeWithLiterals as LinkTypeWithLiteralsOriginal,
  WixLink as WixLinkOriginal,
  WixLinkLinkOneOf as WixLinkLinkOneOfOriginal,
  ExternalLink as ExternalLinkOriginal,
  LinkRel as LinkRelOriginal,
  LinkRelWithLiterals as LinkRelWithLiteralsOriginal,
  PageLink as PageLinkOriginal,
  AnchorLink as AnchorLinkOriginal,
  DynamicPageLink as DynamicPageLinkOriginal,
  DocumentLink as DocumentLinkOriginal,
  EmailLink as EmailLinkOriginal,
  PhoneLink as PhoneLinkOriginal,
  AddressLink as AddressLinkOriginal,
  WhatsAppLink as WhatsAppLinkOriginal,
  TpaPageLink as TpaPageLinkOriginal,
  MediaItem as MediaItemOriginal,
  MediaItemMediaOneOf as MediaItemMediaOneOfOriginal,
  Type as TypeOriginal,
  TypeWithLiterals as TypeWithLiteralsOriginal,
  Image as ImageOriginal,
  CommonImage as CommonImageOriginal,
  FocalPoint as FocalPointOriginal,
  Point as PointOriginal,
  UnsharpMasking as UnsharpMaskingOriginal,
  ExtendedFields as ExtendedFieldsOriginal,
  CreateItemRequest as CreateItemRequestOriginal,
  CreateItemResponse as CreateItemResponseOriginal,
  GetItemRequest as GetItemRequestOriginal,
  GetItemResponse as GetItemResponseOriginal,
  UpdateItemRequest as UpdateItemRequestOriginal,
  UpdateItemResponse as UpdateItemResponseOriginal,
  DeleteItemRequest as DeleteItemRequestOriginal,
  DeleteItemResponse as DeleteItemResponseOriginal,
  QueryItemsRequest as QueryItemsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryItemsResponse as QueryItemsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  UpdateExtendedFieldsRequest as UpdateExtendedFieldsRequestOriginal,
  UpdateExtendedFieldsResponse as UpdateExtendedFieldsResponseOriginal,
  BulkCreateItemsRequest as BulkCreateItemsRequestOriginal,
  BulkCreateItemsResponse as BulkCreateItemsResponseOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkItemResult as BulkItemResultOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  BulkUpdateItemsRequest as BulkUpdateItemsRequestOriginal,
  MaskedItem as MaskedItemOriginal,
  BulkUpdateItemsResponse as BulkUpdateItemsResponseOriginal,
  BulkUpdateItemsResponseBulkItemResult as BulkUpdateItemsResponseBulkItemResultOriginal,
  BulkDeleteItemsRequest as BulkDeleteItemsRequestOriginal,
  BulkDeleteItemsResponse as BulkDeleteItemsResponseOriginal,
  BulkDeleteItemsResponseBulkItemResult as BulkDeleteItemsResponseBulkItemResultOriginal,
  RemoveItemFromTrashBinRequest as RemoveItemFromTrashBinRequestOriginal,
  RemoveItemFromTrashBinResponse as RemoveItemFromTrashBinResponseOriginal,
  RestoreItemFromTrashBinRequest as RestoreItemFromTrashBinRequestOriginal,
  RestoreItemFromTrashBinResponse as RestoreItemFromTrashBinResponseOriginal,
  GetDeletedItemRequest as GetDeletedItemRequestOriginal,
  GetDeletedItemResponse as GetDeletedItemResponseOriginal,
  ListDeletedItemsRequest as ListDeletedItemsRequestOriginal,
  ListDeletedItemsResponse as ListDeletedItemsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './fastgallery-item-v1-item-items.types.js';
